<template>
  <v-list-item-group>
    <v-list-item
      v-for="scan in scans"
      :key="scan.id"
      :disabled="scan.type === 'processing'"
      :to="{ name: 'renderScan', params: { scanId: scan.id, viewType: '3D' }}"
    >
      <v-list-item-icon>
        <v-icon>{{ getIconName(scan) }}</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ scan.name }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list-item-group>
</template>

<script>
export default {
  name: 'ScanListItemGroup',
  props: {
    scans: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getIconName(scan) {
      return {
        processing: 'mdi-cloud-sync',
        ready: 'mdi-cloud-check',
        sample: 'mdi-cube-scan',
      }[scan.type];
    },
  },
};
</script>
